export default __webpack_public_path__ + "static/media/información.99325472.svg";